module.exports = {
	"contractName": "FreeshopFactory",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "createInstance",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_instance",
					"type": "address"
				},
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "validateInstance",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "79:486:14:-;;;501:5:29;:18;;-1:-1:-1;;;;;;501:18:29;509:10;501:18;;;79:486:14;;;;;;",
	"deployedSourceMap": "79:486:14:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;117:240;;-1:-1:-1;;;;;117:240:14;;;;;;;;;-1:-1:-1;;;;;117:240:14;;;;;;;;;;;;;;238:20:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;238:20:29;;;;361:202:14;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;361:202:14;-1:-1:-1;;;;;361:202:14;;;;;;;;;;;;;;;;;;;;;;;;;;;;832:169:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;832:169:29;-1:-1:-1;;;;;832:169:29;;;;;;;117:240:14;182:7;;231;218:9;:20;;210:29;;;;;;268:14;;:::i;:::-;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;-1:-1;288:40:14;;245:37;;-1:-1:-1;;;;;;288:29:14;;;318:9;288:40;;;;;;;;;318:9;288:29;:40;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;-1:-1;341:11:14;117:240;-1:-1:-1;;117:240:14:o;238:20:29:-;;;-1:-1:-1;;;;;238:20:29;;:::o;361:202:14:-;447:4;474:17;503:9;474:39;;526:8;-1:-1:-1;;;;;526:19:14;;:21;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;526:21:14;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;526:21:14;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;526:21:14;:32;;361:202;-1:-1:-1;;;;361:202:14:o;832:169:29:-;653:5;;-1:-1:-1;;;;;653:5:29;639:10;:19;631:28;;;;;;-1:-1:-1;;;;;908:22:29;;;;900:31;;;;;;958:5;;;937:37;;-1:-1:-1;;;;;937:37:29;;;;958:5;;;937:37;;;980:5;:16;;-1:-1:-1;;980:16:29;-1:-1:-1;;;;;980:16:29;;;;;;;;;;832:169::o;79:486:14:-;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.24;\n\nimport \"./base/Level.sol\";\nimport \"./Freeshop.sol\";\n\ncontract FreeshopFactory is Level {\n  function createInstance(address _player) public payable returns (address) {\n    _player;\n    require(msg.value >= 1 ether);\n    Freeshop nowinstance = new Freeshop();\n    address(nowinstance).transfer(msg.value);\n    return nowinstance;\n  }\n\n  function validateInstance(address _instance, address _player)\n    public\n    returns (bool)\n  {\n    _player;\n    Freeshop instance = Freeshop(_instance);\n    return instance.getBalance() == 0 ether;\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/FreeshopFactory.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/FreeshopFactory.sol",
		"exportedSymbols": {
			"FreeshopFactory": [
				1505
			]
		},
		"id": 1506,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1443,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:14"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 1444,
				"nodeType": "ImportDirective",
				"scope": 1506,
				"sourceUnit": 2867,
				"src": "26:26:14",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Freeshop.sol",
				"file": "./Freeshop.sol",
				"id": 1445,
				"nodeType": "ImportDirective",
				"scope": 1506,
				"sourceUnit": 1442,
				"src": "53:24:14",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 1446,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "107:5:14",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 1447,
						"nodeType": "InheritanceSpecifier",
						"src": "107:5:14"
					}
				],
				"contractDependencies": [
					1441,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1505,
				"linearizedBaseContracts": [
					1505,
					2866,
					2922
				],
				"name": "FreeshopFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 1479,
							"nodeType": "Block",
							"src": "191:166:14",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1454,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1449,
										"src": "197:7:14",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1455,
									"nodeType": "ExpressionStatement",
									"src": "197:7:14"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1460,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1457,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "218:3:14",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 1458,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "218:9:14",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 1459,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "231:7:14",
													"subdenomination": "ether",
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													},
													"value": "1"
												},
												"src": "218:20:14",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1456,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "210:7:14",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1461,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "210:29:14",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1462,
									"nodeType": "ExpressionStatement",
									"src": "210:29:14"
								},
								{
									"assignments": [
										1464
									],
									"declarations": [
										{
											"constant": false,
											"id": 1464,
											"name": "nowinstance",
											"nodeType": "VariableDeclaration",
											"scope": 1480,
											"src": "245:20:14",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_Freeshop_$1441",
												"typeString": "contract Freeshop"
											},
											"typeName": {
												"contractScope": null,
												"id": 1463,
												"name": "Freeshop",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1441,
												"src": "245:8:14",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Freeshop_$1441",
													"typeString": "contract Freeshop"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1468,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 1466,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "268:12:14",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$__$returns$_t_contract$_Freeshop_$1441_$",
												"typeString": "function () returns (contract Freeshop)"
											},
											"typeName": {
												"contractScope": null,
												"id": 1465,
												"name": "Freeshop",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1441,
												"src": "272:8:14",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Freeshop_$1441",
													"typeString": "contract Freeshop"
												}
											}
										},
										"id": 1467,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "268:14:14",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Freeshop_$1441",
											"typeString": "contract Freeshop"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "245:37:14"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1473,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "318:3:14",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 1474,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "value",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "318:9:14",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"expression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 1470,
														"name": "nowinstance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1464,
														"src": "296:11:14",
														"typeDescriptions": {
															"typeIdentifier": "t_contract$_Freeshop_$1441",
															"typeString": "contract Freeshop"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_contract$_Freeshop_$1441",
															"typeString": "contract Freeshop"
														}
													],
													"id": 1469,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "288:7:14",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_address_$",
														"typeString": "type(address)"
													},
													"typeName": "address"
												},
												"id": 1471,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "288:20:14",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 1472,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "transfer",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "288:29:14",
											"typeDescriptions": {
												"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
												"typeString": "function (uint256)"
											}
										},
										"id": 1475,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "288:40:14",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1476,
									"nodeType": "ExpressionStatement",
									"src": "288:40:14"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1477,
										"name": "nowinstance",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1464,
										"src": "341:11:14",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Freeshop_$1441",
											"typeString": "contract Freeshop"
										}
									},
									"functionReturnParameters": 1453,
									"id": 1478,
									"nodeType": "Return",
									"src": "334:18:14"
								}
							]
						},
						"documentation": null,
						"id": 1480,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1450,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1449,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1480,
									"src": "141:15:14",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1448,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "141:7:14",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "140:17:14"
						},
						"payable": true,
						"returnParameters": {
							"id": 1453,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1452,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1480,
									"src": "182:7:14",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1451,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "182:7:14",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "181:9:14"
						},
						"scope": 1505,
						"src": "117:240:14",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1503,
							"nodeType": "Block",
							"src": "455:108:14",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1489,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1484,
										"src": "461:7:14",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1490,
									"nodeType": "ExpressionStatement",
									"src": "461:7:14"
								},
								{
									"assignments": [
										1492
									],
									"declarations": [
										{
											"constant": false,
											"id": 1492,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 1504,
											"src": "474:17:14",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_Freeshop_$1441",
												"typeString": "contract Freeshop"
											},
											"typeName": {
												"contractScope": null,
												"id": 1491,
												"name": "Freeshop",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1441,
												"src": "474:8:14",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Freeshop_$1441",
													"typeString": "contract Freeshop"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1496,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1494,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1482,
												"src": "503:9:14",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 1493,
											"name": "Freeshop",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1441,
											"src": "494:8:14",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_Freeshop_$1441_$",
												"typeString": "type(contract Freeshop)"
											}
										},
										"id": 1495,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "494:19:14",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Freeshop_$1441",
											"typeString": "contract Freeshop"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "474:39:14"
								},
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 1501,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"arguments": [],
											"expression": {
												"argumentTypes": [],
												"expression": {
													"argumentTypes": null,
													"id": 1497,
													"name": "instance",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1492,
													"src": "526:8:14",
													"typeDescriptions": {
														"typeIdentifier": "t_contract$_Freeshop_$1441",
														"typeString": "contract Freeshop"
													}
												},
												"id": 1498,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "getBalance",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1436,
												"src": "526:19:14",
												"typeDescriptions": {
													"typeIdentifier": "t_function_external_view$__$returns$_t_uint256_$",
													"typeString": "function () view external returns (uint256)"
												}
											},
											"id": 1499,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "526:21:14",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1500,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "551:7:14",
											"subdenomination": "ether",
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "526:32:14",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 1488,
									"id": 1502,
									"nodeType": "Return",
									"src": "519:39:14"
								}
							]
						},
						"documentation": null,
						"id": 1504,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1485,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1482,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 1504,
									"src": "387:17:14",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1481,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "387:7:14",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1484,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1504,
									"src": "406:15:14",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1483,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "406:7:14",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "386:36:14"
						},
						"payable": false,
						"returnParameters": {
							"id": 1488,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1487,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1504,
									"src": "447:4:14",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1486,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "447:4:14",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "446:6:14"
						},
						"scope": 1505,
						"src": "361:202:14",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 1506,
				"src": "79:486:14"
			}
		],
		"src": "0:566:14"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/FreeshopFactory.sol",
		"exportedSymbols": {
			"FreeshopFactory": [
				1505
			]
		},
		"id": 1506,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1443,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:14"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 1444,
				"nodeType": "ImportDirective",
				"scope": 1506,
				"sourceUnit": 2867,
				"src": "26:26:14",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Freeshop.sol",
				"file": "./Freeshop.sol",
				"id": 1445,
				"nodeType": "ImportDirective",
				"scope": 1506,
				"sourceUnit": 1442,
				"src": "53:24:14",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 1446,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "107:5:14",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 1447,
						"nodeType": "InheritanceSpecifier",
						"src": "107:5:14"
					}
				],
				"contractDependencies": [
					1441,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1505,
				"linearizedBaseContracts": [
					1505,
					2866,
					2922
				],
				"name": "FreeshopFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 1479,
							"nodeType": "Block",
							"src": "191:166:14",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1454,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1449,
										"src": "197:7:14",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1455,
									"nodeType": "ExpressionStatement",
									"src": "197:7:14"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1460,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1457,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "218:3:14",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 1458,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "218:9:14",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 1459,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "231:7:14",
													"subdenomination": "ether",
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													},
													"value": "1"
												},
												"src": "218:20:14",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1456,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "210:7:14",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1461,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "210:29:14",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1462,
									"nodeType": "ExpressionStatement",
									"src": "210:29:14"
								},
								{
									"assignments": [
										1464
									],
									"declarations": [
										{
											"constant": false,
											"id": 1464,
											"name": "nowinstance",
											"nodeType": "VariableDeclaration",
											"scope": 1480,
											"src": "245:20:14",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_Freeshop_$1441",
												"typeString": "contract Freeshop"
											},
											"typeName": {
												"contractScope": null,
												"id": 1463,
												"name": "Freeshop",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1441,
												"src": "245:8:14",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Freeshop_$1441",
													"typeString": "contract Freeshop"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1468,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 1466,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "268:12:14",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$__$returns$_t_contract$_Freeshop_$1441_$",
												"typeString": "function () returns (contract Freeshop)"
											},
											"typeName": {
												"contractScope": null,
												"id": 1465,
												"name": "Freeshop",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1441,
												"src": "272:8:14",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Freeshop_$1441",
													"typeString": "contract Freeshop"
												}
											}
										},
										"id": 1467,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "268:14:14",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Freeshop_$1441",
											"typeString": "contract Freeshop"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "245:37:14"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1473,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2937,
													"src": "318:3:14",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 1474,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "value",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "318:9:14",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"expression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 1470,
														"name": "nowinstance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1464,
														"src": "296:11:14",
														"typeDescriptions": {
															"typeIdentifier": "t_contract$_Freeshop_$1441",
															"typeString": "contract Freeshop"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_contract$_Freeshop_$1441",
															"typeString": "contract Freeshop"
														}
													],
													"id": 1469,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "288:7:14",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_address_$",
														"typeString": "type(address)"
													},
													"typeName": "address"
												},
												"id": 1471,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "288:20:14",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 1472,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "transfer",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "288:29:14",
											"typeDescriptions": {
												"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
												"typeString": "function (uint256)"
											}
										},
										"id": 1475,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "288:40:14",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1476,
									"nodeType": "ExpressionStatement",
									"src": "288:40:14"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1477,
										"name": "nowinstance",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1464,
										"src": "341:11:14",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Freeshop_$1441",
											"typeString": "contract Freeshop"
										}
									},
									"functionReturnParameters": 1453,
									"id": 1478,
									"nodeType": "Return",
									"src": "334:18:14"
								}
							]
						},
						"documentation": null,
						"id": 1480,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1450,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1449,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1480,
									"src": "141:15:14",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1448,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "141:7:14",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "140:17:14"
						},
						"payable": true,
						"returnParameters": {
							"id": 1453,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1452,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1480,
									"src": "182:7:14",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1451,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "182:7:14",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "181:9:14"
						},
						"scope": 1505,
						"src": "117:240:14",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1503,
							"nodeType": "Block",
							"src": "455:108:14",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1489,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 1484,
										"src": "461:7:14",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1490,
									"nodeType": "ExpressionStatement",
									"src": "461:7:14"
								},
								{
									"assignments": [
										1492
									],
									"declarations": [
										{
											"constant": false,
											"id": 1492,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 1504,
											"src": "474:17:14",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_Freeshop_$1441",
												"typeString": "contract Freeshop"
											},
											"typeName": {
												"contractScope": null,
												"id": 1491,
												"name": "Freeshop",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 1441,
												"src": "474:8:14",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Freeshop_$1441",
													"typeString": "contract Freeshop"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1496,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1494,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1482,
												"src": "503:9:14",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 1493,
											"name": "Freeshop",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1441,
											"src": "494:8:14",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_Freeshop_$1441_$",
												"typeString": "type(contract Freeshop)"
											}
										},
										"id": 1495,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "494:19:14",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Freeshop_$1441",
											"typeString": "contract Freeshop"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "474:39:14"
								},
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 1501,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"arguments": [],
											"expression": {
												"argumentTypes": [],
												"expression": {
													"argumentTypes": null,
													"id": 1497,
													"name": "instance",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1492,
													"src": "526:8:14",
													"typeDescriptions": {
														"typeIdentifier": "t_contract$_Freeshop_$1441",
														"typeString": "contract Freeshop"
													}
												},
												"id": 1498,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "getBalance",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1436,
												"src": "526:19:14",
												"typeDescriptions": {
													"typeIdentifier": "t_function_external_view$__$returns$_t_uint256_$",
													"typeString": "function () view external returns (uint256)"
												}
											},
											"id": 1499,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "526:21:14",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 1500,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "551:7:14",
											"subdenomination": "ether",
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "526:32:14",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 1488,
									"id": 1502,
									"nodeType": "Return",
									"src": "519:39:14"
								}
							]
						},
						"documentation": null,
						"id": 1504,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1485,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1482,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 1504,
									"src": "387:17:14",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1481,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "387:7:14",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 1484,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 1504,
									"src": "406:15:14",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1483,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "406:7:14",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "386:36:14"
						},
						"payable": false,
						"returnParameters": {
							"id": 1488,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1487,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1504,
									"src": "447:4:14",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1486,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "447:4:14",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "446:6:14"
						},
						"scope": 1505,
						"src": "361:202:14",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 1506,
				"src": "79:486:14"
			}
		],
		"src": "0:566:14"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.802Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/FreeshopFactory.json
// module id = 1040
// module chunks = 0